/* Rooms index — client-side faceted filtering of the curated-space grid.
   Facet groups (room / temp / energy / season) are OR within a group, AND across
   groups. All 30 rooms render server-side; this just toggles visibility. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rooms-index]');
  if (!root) return;
  var grid = root.querySelector('[data-rooms-grid]');
  var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('.rooms-card')) : [];
  if (!cards.length) return;
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-filter-group]'));
  var resets = Array.prototype.slice.call(root.querySelectorAll('[data-filter-reset]'));
  var countEl = root.querySelector('[data-rooms-count]');
  var emptyEl = root.querySelector('[data-rooms-empty]');
  var active = {}; // group -> { value: true }

  function activeGroups() {
    return Object.keys(active).filter(function (g) { return Object.keys(active[g] || {}).length; });
  }

  function apply() {
    var groups = activeGroups();
    var visible = 0;
    cards.forEach(function (card) {
      var ok = groups.every(function (g) {
        var val = (card.getAttribute('data-' + g) || '').toLowerCase();
        return !!active[g][val];
      });
      card.classList.toggle('rooms-card--hidden', !ok);
      if (ok) visible++;
    });
    if (countEl) countEl.textContent = visible + (visible === 1 ? ' room' : ' rooms');
    if (emptyEl) emptyEl.classList.toggle('hidden', visible > 0);
    resets.forEach(function (b) { b.classList.toggle('rooms-chip--active', groups.length === 0); });
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var g = chip.getAttribute('data-filter-group');
      var v = (chip.getAttribute('data-filter-value') || '').toLowerCase();
      active[g] = active[g] || {};
      if (active[g][v]) { delete active[g][v]; chip.classList.remove('rooms-chip--active'); }
      else { active[g][v] = true; chip.classList.add('rooms-chip--active'); }
      apply();
    });
  });

  resets.forEach(function (btn) {
    btn.addEventListener('click', function () {
      active = {};
      chips.forEach(function (c) { c.classList.remove('rooms-chip--active'); });
      apply();
    });
  });

  apply();
})();
